import { FormEvent, useState } from 'react';
import { connect } from 'react-redux';
import { Dispatch, bindActionCreators } from 'redux';
import { Link } from 'react-router';
import { FormattedMessage, useIntl } from 'react-intl';
import * as validation from 'myParkdUtils/validationHandling';
import placeholders from 'string-translations/placeholders';
import UpperNavBar from 'components/board/UpperNavBar';
import SubmitButton from 'components/SubmitButton';
import BackToLoginButton from 'components/BackToLoginButton';
import ErrorMessage from 'components/ErrorMessage';
import { authSlice } from 'features/auth/authSlice';


type Errors = {
    email?: any
}


const EmailHasBeenSentMessage = ({ email }: { email: string }) => {
    return (
        <div>
            <div className="box-400 myparkd-box">
                <p className="greater center">
                    <FormattedMessage id="RESET_PASSWORD_MAIL_SENT" />
                    <br />
                    <span className="txt-green">{email}</span>
                </p>
                <Link to="/login" className="btn-blue full-width">
                    <FormattedMessage id="GLOBAL_LOGIN" />
                </Link>
            </div>
        </div>
    );
};


export const ResetPasswordScreen = (props: any) => {
    const [email, setEmail] = useState<string>('');
    const [formSubmitted, setFormSubmitted] = useState<boolean>(false);
    const [showValidationErrors, setShowValidationErrors] = useState<boolean>(false);

    const { formatMessage } = useIntl();

    const getValidationErrors = () => {
        let errors: Errors = {};
        errors.email = validation.checkIfValidEmailAddress(email);
        return errors;
    };

    const handleSubmit = (e: FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        const validationSuccessful = validation.validate(getValidationErrors());
        if (validationSuccessful) {
            props.resetPassword({ email });
            setFormSubmitted(true);
        } else {
            setShowValidationErrors(true);
        }
    };

    const errors = getValidationErrors();
    const validationSuccessful = validation.validate(errors);


    return (
        <div className='page bg-blue'>
            <div className='grid-viewport'>
                <UpperNavBar />
            </div>

            <div id="screen-reset-password" className="panel radius-rectangle full-width-form">
                <div className="panel-header">
                    <BackToLoginButton />
                    <h1 className="bold-title center">
                        <FormattedMessage id="RESET_YOUR_PASSWORD" />
                    </h1>
                </div>
                <div className="panel-content">
                    {formSubmitted ? (
                        <EmailHasBeenSentMessage email={email} />
                    ) : (
                        <div>
                            <p className="center">
                                <FormattedMessage id="RESET_PASSWORD_STRUGGLING_TO_LOGIN" />
                            </p>

                            <form
                                onSubmit={handleSubmit}
                                noValidate
                                className={
                                    (validationSuccessful ? 'validation-successful ' : '') +
                                    (showValidationErrors ? 'show-validation-messages' : 'hide-validation-messages')
                                }
                            >
                                <label htmlFor="resetEmail">
                                    <FormattedMessage id="EMAIL" />:
                                </label>
                                <input
                                    type="email"
                                    className={'text-field ' + (errors.email ? 'error' : 'valid')}
                                    placeholder={formatMessage(placeholders.email)}
                                    required
                                    autoComplete="email"
                                    onChange={(e) => setEmail(e.target.value)}
                                />
                                <ErrorMessage msg={errors.email} />

                                <div className="center">
                                    <SubmitButton buttonText={formatMessage({ id: 'RESET_PASSWORD' })} />
                                </div>
                            </form>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
}


function mapDispatchToProps(dispatch: Dispatch<any>) {
    return bindActionCreators({
        resetPassword: authSlice.actions.resetPassword,
    }, dispatch
    );
}

export default connect(null, mapDispatchToProps)(ResetPasswordScreen);